import React, { useState } from 'react'
import $ from 'jquery'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'


export default function Forgotpassword() {
   const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [emailInput, setEmailInput] = useState(!token);
    const [passInput, setPassInput] = useState(!!token);

    const [loading, setLoading] = useState(false);

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Send reset email
    |--------------------------------------------------------------------------
    */

    const prepareChangePass = async (e) => {

        e.preventDefault();

        setError("");
        setMessage("");

        if (!email.trim()) {

            setError("Please enter your email address.");
            return;
        }

        setLoading(true);

        try {

            const formData = new URLSearchParams();

            formData.append("uemail", email.trim());


            const response = await fetch(
                "forgotPassword.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type":
                            "application/x-www-form-urlencoded"
                    },
                    body: formData.toString()
                }
            );


            const result = await response.json();
            console.log(result);


            if (result.success) {

                setMessage(
                    "A password reset link has been sent to your email. Please check your inbox"
                );

            } else {

                setError(
                    result.message || "Unable to process your request."
                );
            }

        } catch (error) {

            console.error(error);

            setError(
                "Something went wrong. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Change password
    |--------------------------------------------------------------------------
    */

    const changePass = async (e) => {

        e.preventDefault();

        setError("");
        setMessage("");


        /*
        |--------------------------------------------------------------------------
        | Validate password
        |--------------------------------------------------------------------------
        */

        if (!password) {

            setError("Please enter a new password.");
            return;
        }


        if (password.length < 8) {

            setError(
                "Password must contain at least 8 characters."
            );

            return;
        }


        if (password !== confirmPassword) {

            setError(
                "Password and confirm password do not match."
            );

            return;
        }


        if (!token) {

            setError(
                "Invalid password reset link."
            );

            return;
        }


        setLoading(true);


        try {

            const formData = new URLSearchParams();

            formData.append("token", token);
            formData.append("password", password);


            const response = await fetch(
                "resetPassword.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type":
                            "application/x-www-form-urlencoded"
                    },
                    body: formData.toString()
                }
            );


            const result = await response.json();


            if (result.success) {

                setMessage(
                    "Your password has been changed successfully."
                );


                setTimeout(() => {

                    navigate("/");

                }, 2000);


            } else {

                setError(
                    result.message ||
                    "Unable to change your password."
                );
            }


        } catch (error) {

            console.error(error);

            setError(
                "Something went wrong. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Cancel
    |--------------------------------------------------------------------------
    */

    const cancelChangePass = () => {

        navigate("/");
    };


    return (

        <div className="floatcontainer">


            {/* =========================================================
                EMAIL FORM
            ========================================================= */}

            {emailInput && (

                <div
                    className="inner_form_holder"
                    id="email_input"
                >

                    <h2>
                        Forgot Password
                    </h2>


                    <p>
                        Enter the email address associated with
                        your account.
                    </p>


                    <form
                        className="case"
                        onSubmit={prepareChangePass}
                    >

                        <input
                            type="email"
                            id="useremail"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value)
                            }
                            required
                        />


                        {error && (

                            <div className="error_message">
                                {error}
                            </div>

                        )}


                        {message && (

                            <div className="success_message">
                                {message}
                            </div>

                        )}


                        <button
                            type="submit"
                            disabled={loading}
                        >

                            {loading
                                ? "Please wait..."
                                : "Send Reset Link"
                            }

                        </button>


                        <button
                            type="button"
                            onClick={cancelChangePass}
                        >
                            Cancel
                        </button>

                    </form>

                </div>

            )}


            {/* =========================================================
                PASSWORD FORM
            ========================================================= */}

            {passInput && (

                <div
                    className="inner_form_holder"
                    id="pass_input"
                >

                    <h2>
                        Create New Password
                    </h2>


                    <p>
                        Please enter your new password below.
                    </p>


                    <form
                        className="case"
                        onSubmit={changePass}
                    >

                        <input
                            type="password"
                            id="userpass"
                            placeholder="Enter new password"
                            value={password}
                            onChange={(e) =>
                                setPassword(e.target.value)
                            }
                            required
                        />


                        <input
                            type="password"
                            id="confpass"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) =>
                                setConfirmPassword(e.target.value)
                            }
                            required
                        />


                        {error && (

                            <div className="error_message">
                                {error}
                            </div>

                        )}


                        {message && (

                            <div className="success_message">
                                {message}
                            </div>

                        )}


                        <button
                            type="submit"
                            disabled={loading}
                        >

                            {loading
                                ? "Saving..."
                                : "Save Password"
                            }

                        </button>

                    </form>

                </div>

            )}

        </div>
    );
}
